import { createFileRoute } from '@tanstack/react-router'

import { GitHubSettingsPage } from '#features/integrations/github/github-settings-page'

export const Route = createFileRoute(
  '/_app/$workspace/settings/integrations/github',
)({
  head: () => ({
    meta: [
      {
        title: 'GitHub integration',
      },
    ],
  }),
  component: () => <GitHubSettingsPage />,
})
